import { Component } from '@angular/core';

@Component({
  selector: 'ic-builder-isplaceholder',
  templateUrl: './isplaceholder.component.html',
  styleUrls: ['./isplaceholder.component.scss'],
})
export class IsplaceholderComponent {}
